<template>
  <div :class="`new-folder dialog-wraper ${!sfolder ? 'with-border' : ''}`">
    <div class="folder-name" v-if="!sfolder">
      <div class="form-input">
        <p class="dialog-label" v-cloak>{{isFolder ? $t('Newfolderlabel') : $t('Newfilelabel')}}</p>
        <el-input
          maxlength="100"
          ref="input"
          :placeholder="isFolder ? $t('Newfolderinfo') : $t('Newfileinfo')"
          @keyup.native.enter="create"
          v-model.trim="name"
        >
          <template v-if="!isFolder" slot="append">.{{action}}</template>
        </el-input>
      </div>
      <div class="form-input form-folder">
        <p class="dialog-label" v-t="'Position'"></p>
        <div class="folder-selected" @click="() => this.sfolder = true">
          <div class="position-box">
            <span class="components-icons-box folder-icon">
              <i class="components-icons components-icons-folder-s-selected">
                <span class="path1"></span>
              </i>
            </span>
            <!-- <span :title="folder" class="position">{{folder}}</span> -->
            <span
              class="nowrap"
              v-text="folder.length > 50 ? (folder.slice(0,50) + '...') : folder"
              :title="folder"
            ></span>
          </div>
          <span class="components-icons-box">
            <i class="components-icons components-icons-down">
              <span class="path1"></span>
            </i>
          </span>
        </div>
      </div>
    </div>
    <tree v-if="sfolder" ref="tree" @checked="checked"></tree>
    <div class="dialog-foot">
      <el-button size="mini" @click="cancel" v-cloak>{{$t('Cancel')}}</el-button>
      <el-button
        :loading="doing"
        :disabled="disabled"
        @click="create"
        type="primary"
        size="mini"
        v-cloak
      >{{$t('Confirm')}}</el-button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import Tree from "./file/Tree";
export default {
  data() {
    return {
      name: "",
      parentid: 0,
      groupid: 0,
      sfolder: false,
      newIn: "",
      data: {}
    };
  },
  components: {
    Tree
  },
  mounted() {
    this.$refs.input.focus();
    if (this.route == "teams") {
      let { tid, fid } = this.$route.params;
      this.groupid = tid;
      this.parentid = fid;
    }
  },
  computed: {
    folder() {
      let len = this.mbread.length;
      let bread = len ? this.mbread[len - 1] : "";
      let { name } = this.$route;
      if (name == "trash" || name == "trashFolder") {
        return this.$t("Mycloud");
      } else if (this.newIn) {
        return this.newIn;
      } else if (bread) {
        this.parentid = bread.fileid;
        return bread.fname;
      } else {
        return this.route == "teams" &&
          this.teams.length &&
          this.groupid != this.group
          ? this.$t("TeamFiles")
          : this.$t("Mycloud");
      }
    },
    isFolder() {
      let typeArr = ["ppt", "xls", "doc"];
      return typeArr.indexOf(this.action) < 0;
    },
    ...mapState(["group", "action", "route"]),
    ...mapState("index", ["breads", "doing", "createData"]),
    ...mapState("team", ["teamLoading", "teams"]),
    mbread() {
      let tbreads = this.$store.state.team.breads;
      return this.route == "teams" ? tbreads : this.breads;
    },
    disabled() {
      return !this.name && !this.sfolder;
    }
  },
  methods: {
    ...mapActions(["close"]),
    ...mapActions("index", ["doCreate", "creatFile"]),
    cancel() {
      this.sfolder ? (this.sfolder = false) : this.close();
    },
    create() {
      if (this.disabled) {
        return;
      } else if (this.sfolder) {
        let { fname, id, user_role, name, groupid } = this.data;
        this.newIn = user_role ? name : fname;
        this.groupid = groupid || id;
        this.parentid = groupid ? id : 0;
        this.sfolder = false;
      } else {
        let groupid = this.groupid || this.group;
        this.doCreate({
          groupid,
          parentid: this.parentid || 0,
          name: this.isFolder ? this.name : `${this.name}.${this.action}`,
          type: this.action
        });
      }
    },
    checked(data) {
        console.log(data)
      this.data = data;
    },
    isCef() {
      return window.cefQuery;
    }
  },
  watch: {
    createData(cur) {
      let [{ ftype, id }, query] = [cur, this.$route.query];
      if (ftype == "folder") {
        this.route == "teams"
          ? this.$router.push({
              name: "teamFolder",
              params: {
                tid: this.$route.params.tid,
                fid: id
              },
              query
            })
          : this.$router.push({
              name: "folder",
              params: {
                pid: id
              },
              query
            });
      } else if (ftype == "file" && !window.cefQuery) {
        let { href } = this.$router.resolve({
          name: "preview",
          params: {
            fileid: id
          },
          query
        });
        window.open(href);
      }
      this.close();
    }
  }
};
</script>

<style>
.form-folder {
  margin-top: 24px;
}
.folder-selected {
  height: 32px;
  border-radius: 2px;
  display: block;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  padding: 3px 10px;
  box-sizing: border-box;
  line-height: 26px;
}
.folder-selected:hover {
  border: 1px solid #2e68f8;
}
.position-box {
  display: flex;
  min-width: 0;
  flex: 1;
}
.position-box .folder-icon {
  margin-right: 10px;
}
.el-input-group__append {
  padding: 0 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/Create.vue